import { createI18n } from 'vue-i18n';
import en_home from './locales/en/home.json';
import pt_home from './locales/pt/home.json';
import es_home from './locales/es/home.json';
import zh_home from './locales/zh/home.json';

import en_house from './locales/en/house.json';
import pt_house from './locales/pt/house.json';
import es_house from './locales/es/house.json';
import zh_house from './locales/zh/house.json';

import en_login from './locales/en/login.json';
import pt_login from './locales/pt/login.json';
import es_login from './locales/es/login.json';
import zh_login from './locales/zh/login.json';

import en_header from './locales/en/header.json';
import pt_header from './locales/pt/header.json';
import es_header from './locales/es/header.json';
import zh_header from './locales/zh/header.json';

import en_fishing from './locales/en/fishing.json';
import pt_fishing from './locales/pt/fishing.json';
import es_fishing from './locales/es/fishing.json';
import zh_fishing from './locales/zh/fishing.json';

import en_fishes from './locales/en/fishes.json';
import pt_fishes from './locales/pt/fishes.json';
import es_fishes from './locales/es/fishes.json';
import zh_fishes from './locales/zh/fishes.json';

import en_shop from './locales/en/shop.json';
import pt_shop from './locales/pt/shop.json';
import es_shop from './locales/es/shop.json';
import zh_shop from './locales/zh/shop.json';

import en_inventory from './locales/en/inventory.json';
import pt_inventory from './locales/pt/inventory.json';
import es_inventory from './locales/es/inventory.json';
import zh_inventory from './locales/zh/inventory.json';

import en_configs from './locales/en/configs.json';
import pt_configs from './locales/pt/configs.json';
import es_configs from './locales/es/configs.json';
import zh_configs from './locales/zh/configs.json';

import en_footer from './locales/en/footer.json';
import pt_footer from './locales/pt/footer.json';
import es_footer from './locales/es/footer.json';
import zh_footer from './locales/zh/footer.json';

import en_roulette from './locales/en/roulette.json';
import pt_roulette from './locales/pt/roulette.json';
import es_roulette from './locales/es/roulette.json';
import zh_roulette from './locales/zh/roulette.json';

import en_maps from './locales/en/maps.json';
import pt_maps from './locales/pt/maps.json';
import es_maps from './locales/es/maps.json';
import zh_maps from './locales/zh/maps.json';

import en_purchase from './locales/en/purchase.json';
import pt_purchase from './locales/pt/purchase.json';
import es_purchase from './locales/es/purchase.json';
import zh_purchase from './locales/zh/purchase.json';

import en_error404 from './locales/en/error404.json';
import pt_error404 from './locales/pt/error404.json';
import es_error404 from './locales/es/error404.json';
import zh_error404 from './locales/zh/error404.json';

import en_share from './locales/en/share.json';
import pt_share from './locales/pt/share.json';
import es_share from './locales/es/share.json';
import zh_share from './locales/zh/share.json';

import en_dailyReward from './locales/en/dailyReward.json';
import pt_dailyReward from './locales/pt/dailyReward.json';
import es_dailyReward from './locales/es/dailyReward.json';
import zh_dailyReward from './locales/zh/dailyReward.json';

import en_events from './locales/en/events.json';
import pt_events from './locales/pt/events.json';
import es_events from './locales/es/events.json';
import zh_events from './locales/zh/events.json';

import en_confirmEmail from './locales/en/confirmEmail.json';
import es_confirmEmail from './locales/es/confirmEmail.json';
import zh_confirmEmail from './locales/zh/confirmEmail.json';
import pt_confirmEmail from './locales/pt/confirmEmail.json';

import en_competitions from './locales/en/competitions.json';
import pt_competitions from './locales/pt/competitions.json';
import es_competitions from './locales/es/competitions.json';
import zh_competitions from './locales/zh/competitions.json';

import en_upgrade from './locales/en/upgrade.json';
import pt_upgrade from './locales/pt/upgrade.json';
import es_upgrade from './locales/es/upgrade.json';
import zh_upgrade from './locales/zh/upgrade.json';

import en_market from './locales/en/market.json';
import pt_market from './locales/pt/market.json';
import es_market from './locales/es/market.json';
import zh_market from './locales/zh/market.json';
import en_skills from './locales/en/skills.json';
import pt_skills from './locales/pt/skills.json';
import es_skills from './locales/es/skills.json';
import zh_skills from './locales/zh/skills.json';

import en_dailyMissions from './locales/en/dailyMissions.json';
import pt_dailyMissions from './locales/pt/dailyMissions.json';
import es_dailyMissions from './locales/es/dailyMissions.json';
import zh_dailyMissions from './locales/zh/dailyMissions.json';

// Import business translations
import en_business from './locales/en/business.json';
import pt_business from './locales/pt/business.json';
import es_business from './locales/es/business.json';
import zh_business from './locales/zh/business.json';

// Import clan translations
import en_exploration from './locales/en/exploration.json';
import pt_exploration from './locales/pt/exploration.json';
import es_exploration from './locales/es/exploration.json';
import zh_exploration from './locales/zh/exploration.json';

import en_clan from './locales/en/clan.json';
import pt_clan from './locales/pt/clan.json';
import es_clan from './locales/es/clan.json';
import zh_clan from './locales/zh/clan.json';

import en_profile from './locales/en/profile.json';
import pt_profile from './locales/pt/profile.json';
import es_profile from './locales/es/profile.json';
import zh_profile from './locales/zh/profile.json';

const i18n = createI18n({
  legacy: false, // Enable Composition API mode
  globalInjection: true,
  locale: 'pt',
  fallbackLocale: 'en',
  fallbackWarn: false,
  missingWarn: false,
  silentTranslationWarn: true,
  messages: {
    en: {
      ...en_home,
      ...en_house,
      ...en_business,
      clan: en_clan,
      exploration: en_exploration,
      login: en_login,
      header: en_header,
      fishing: en_fishing,
      ...en_fishes,
      ...en_shop,
      ...en_inventory,
      configs: en_configs,
      ...en_footer,
      roulette: en_roulette,
      maps: en_maps,
      purchase: en_purchase,
      error404: en_error404,
      share: en_share,
      dailyReward: en_dailyReward,
      events: en_events,
      ...en_confirmEmail,
      competitions: en_competitions.competitions,
      upgrade: en_upgrade,
      skills: en_skills,
      market: en_market,
      dailyMissions: en_dailyMissions,
      profile: en_profile,
      common: {
        cancel: "Cancel",
        close: "Close",
        confirm: "Confirm",
        paginacao: {
          rotulo: "Pages",
          anterior: "Previous page",
          proxima: "Next page",
          pagina: "Page {n}",
          faixa: "{de}–{ate} of {total}"
        }
      },
      buttonText: {
        default: "What could it be? 🤔",
        good1: "Wonderful! 🎉 Let's celebrate!",
        good2: "Incredible! 🌟 Luck is on our side!",
        good3: "Great news! 🎯 Enjoy the moment!",
        good4: "Fantastic! 🌈 Keep it up!",
        good5: "A blessing from the seas! 🌊 Onward!",
        good6: "The winds are in our favor! 💨",
        bad1: "What bad luck... 😢 Better luck next time!",
        bad2: "Tough days at sea... 🌧️ We'll overcome!",
        bad3: "Storm ahead! ⛈️ We must resist!",
        bad4: "Low tide today... 😔 But don't give up!",
        bad5: "The fish aren't cooperating... 🐟 Patience!",
        bad6: "Turbulent waters... 🌊 Stay strong!",
        neutral1: "Interesting! 🤔 Let's see what happens!",
        neutral2: "Hmm... 🎲 Fate is unpredictable!",
        neutral3: "Curious situation... 👀 Let's see!",
        neutral4: "The waters are mysterious... 🌊 Let's discover!",
        neutral5: "A new challenge presents itself! 🎯",
        neutral6: "The sea brings surprises! 🐠"
      },
      selectPaymentMethod: "Select Payment Method",
      creditCard: "Credit Card",
      boleto: "Boleto (Brazil)",
      cancel: "Cancel",
      duration: "Duration",
      days: "days",
      shopTitle: "Paralleliums Shop",
      popularChoice: "Chosen by over 72% of players",
      currency: "Paralleliums",
      price: "Price",
      buy: "Buy",
      cookies: {
        message: "Ahoy, adventurer! We use magical cookies to enhance your fishing experience! Will you accept our mystical treats?",
        accept: "Accept the Magic!"
      }
    },
    pt: {
      ...pt_home,
      ...pt_house,
      ...pt_business,
      clan: pt_clan,
      exploration: pt_exploration,
      login: pt_login,
      header: pt_header,
      fishing: pt_fishing,
      ...pt_fishes,
      ...pt_shop,
      ...pt_inventory,
      configs: pt_configs,
      ...pt_footer,
      roulette: pt_roulette,
      maps: pt_maps,
      purchase: pt_purchase,
      error404: pt_error404,
      share: pt_share,
      dailyReward: pt_dailyReward,
      events: pt_events,
      ...pt_confirmEmail,
      competitions: pt_competitions.competitions,
      upgrade: pt_upgrade,
      skills: pt_skills,
      market: pt_market,
      dailyMissions: pt_dailyMissions,
      profile: pt_profile,
      common: {
        cancel: "Cancelar",
        close: "Fechar",
        confirm: "Confirmar",
        paginacao: {
          rotulo: "Páginas",
          anterior: "Página anterior",
          proxima: "Próxima página",
          pagina: "Página {n}",
          faixa: "{de}–{ate} de {total}"
        }
      },
      buttonText: {
        default: "O que será que vem aí? 🤔",
        good1: "Que maravilha! 🎉 Vamos comemorar!",
        good2: "Incrível! 🌟 A sorte está ao nosso lado!",
        good3: "Ótimas notícias! 🎯 Aproveite o momento!",
        good4: "Fantástico! 🌈 Que continue assim!",
        good5: "Uma benção dos mares! 🌊 Avante!",
        good6: "Os ventos sopram a nosso favor! 💨",
        bad1: "Que azar... 😢 Melhor sorte na próxima vez!",
        bad2: "Dias difíceis no mar... 🌧️ Vamos superar!",
        bad3: "Tempestade à vista! ⛈️ Precisamos resistir!",
        bad4: "Maré baixa hoje... 😔 Mas não desista!",
        bad5: "Os peixes não estão cooperando... 🐟 Paciência!",
        bad6: "Águas turbulentas... 🌊 Mantenha-se firme!",
        neutral1: "Interessante! 🤔 Vamos ver o que acontece!",
        neutral2: "Hmm... 🎲 O destino é imprevisível!",
        neutral3: "Curiosa situação... 👀 Vejamos no que dá!",
        neutral4: "As águas estão misteriosas... 🌊 Vamos descobrir!",
        neutral5: "Um novo desafio se apresenta! 🎯",
        neutral6: "O mar nos traz surpresas! 🐠"
      },
      selectPaymentMethod: "Selecione a Forma de Pagamento",
      creditCard: "Cartão de Crédito",
      boleto: "Boleto",
      cancel: "Cancelar",
      duration: "Duração",
      days: "dias",
      shopTitle: "Loja de Paralleliums",
      popularChoice: "Escolha de mais de 62% dos jogadores",
      currency: "Paralleliums",
      price: "Preço",
      buy: "Comprar",
      cookies: {
        message: "Olá, aventureiro! Usamos cookies mágicos para melhorar sua experiência de pesca! Aceita nossas guloseimas místicas?",
        accept: "Aceitar a Magia!"
      }
    },
    es: {
      ...es_home,
      ...es_house,
      ...es_business,
      clan: es_clan,
      exploration: es_exploration,
      login: es_login,
      header: es_header,
      fishing: es_fishing,
      ...es_fishes,
      ...es_shop,
      ...es_inventory,
      configs: es_configs,
      ...es_footer,
      roulette: es_roulette,
      maps: es_maps,
      purchase: es_purchase,
      error404: es_error404,
      share: es_share,
      dailyReward: es_dailyReward,
      events: es_events,
      ...es_confirmEmail,
      competitions: es_competitions.competitions,
      upgrade: es_upgrade,
      skills: es_skills,
      market: es_market,
      dailyMissions: es_dailyMissions,
      profile: es_profile,
      common: {
        cancel: "Cancelar",
        close: "Cerrar",
        confirm: "Confirmar",
        paginacao: {
          rotulo: "Páginas",
          anterior: "Página anterior",
          proxima: "Página siguiente",
          pagina: "Página {n}",
          faixa: "{de}–{ate} de {total}"
        }
      },
      buttonText: {
        default: "¿Qué podría ser? 🤔",
        good1: "¡Maravilloso! 🎉 ¡Vamos a celebrar!",
        good2: "¡Increíble! 🌟 ¡La suerte está de nuestro lado!",
        good3: "¡Grandes noticias! 🎯 ¡Disfruta el momento!",
        good4: "¡Fantástico! 🌈 ¡Sigue así!",
        good5: "¡Una bendición de los mares! 🌊 ¡Adelante!",
        good6: "¡Los vientos están a nuestro favor! 💨",
        bad1: "Qué mala suerte... 😢 ¡Mejor suerte la próxima vez!",
        bad2: "Días difíciles en el mar... 🌧️ ¡Superaremos!",
        bad3: "¡Tormenta a la vista! ⛈️ ¡Debemos resistir!",
        bad4: "Marea baja hoy... 😔 ¡Pero no te rindas!",
        bad5: "Los peces no están cooperando... 🐟 ¡Paciencia!",
        bad6: "Aguas turbulentas... 🌊 ¡Mantente fuerte!",
        neutral1: "¡Interesante! 🤔 ¡Veamos qué pasa!",
        neutral2: "Hmm... 🎲 ¡El destino es impredecible!",
        neutral3: "Situación curiosa... 👀 ¡Veamos!",
        neutral4: "Las aguas son misteriosas... 🌊 ¡Descubramos!",
        neutral5: "¡Un nuevo desafío se presenta! 🎯",
        neutral6: "¡El mar trae sorpresas! 🐠"
      },
      selectPaymentMethod: "Seleccionar Método de Pago",
      creditCard: "Tarjeta de Crédito",
      boleto: "Boleto (Brasil)",
      cancel: "Cancelar",
      duration: "Duración",
      days: "días",
      shopTitle: "Tienda de Paralleliums",
      popularChoice: "Elegido por más del 72% de los jugadores",
      currency: "Paralleliums",
      price: "Precio",
      buy: "Comprar",
      cookies: {
        message: "¡Hola, aventurero! ¡Usamos cookies mágicas para mejorar tu experiencia de pesca! ¿Aceptas nuestros dulces místicos?",
        accept: "¡Aceptar la Magia!"
      }
    },
    zh: {
      ...zh_home,
      ...zh_house,
      ...zh_business,
      clan: zh_clan,
      exploration: zh_exploration,
      login: zh_login,
      header: zh_header,
      fishing: zh_fishing,
      ...zh_fishes,
      ...zh_shop,
      ...zh_inventory,
      configs: zh_configs,
      ...zh_footer,
      roulette: zh_roulette,
      maps: zh_maps,
      purchase: zh_purchase,
      error404: zh_error404,
      share: zh_share,
      dailyReward: zh_dailyReward,
      events: zh_events,
      ...zh_confirmEmail,
      competitions: zh_competitions.competitions,
      upgrade: zh_upgrade,
      skills: zh_skills,
      market: zh_market,
      dailyMissions: zh_dailyMissions,
      profile: zh_profile,
      common: {
        cancel: "取消",
        close: "关闭",
        confirm: "确认",
        paginacao: {
          rotulo: "分页",
          anterior: "上一页",
          proxima: "下一页",
          pagina: "第 {n} 页",
          faixa: "第 {de}–{ate} 项，共 {total} 项"
        }
      },
      buttonText: {
        default: "会是什么呢？🤔",
        good1: "太棒了！🎉 让我们庆祝吧！",
        good2: "不可思议！🌟 幸运在我们这边！",
        good3: "好消息！🎯 享受这一刻！",
        good4: "太好了！🌈 继续保持！",
        good5: "海洋的祝福！🌊 前进！",
        good6: "风在我们这边！💨",
        bad1: "真倒霉... 😢 下次好运！",
        bad2: "海上艰难的日子... 🌧️ 我们会克服的！",
        bad3: "前方有风暴！⛈️ 我们必须坚持！",
        bad4: "今天是低潮... 😔 但不要放弃！",
        bad5: "鱼不合作... 🐟 耐心点！",
        bad6: "波涛汹涌... 🌊 保持坚强！",
        neutral1: "有趣！🤔 让我们看看会发生什么！",
        neutral2: "嗯... 🎲 命运是不可预测的！",
        neutral3: "好奇的情况... 👀 让我们看看！",
        neutral4: "水域神秘... 🌊 让我们发现！",
        neutral5: "一个新的挑战出现了！🎯",
        neutral6: "大海带来了惊喜！🐠"
      },
      selectPaymentMethod: "选择支付方式",
      creditCard: "信用卡",
      boleto: "Boleto（巴西）",
      cancel: "取消",
      duration: "持续时间",
      days: "天",
      shopTitle: "Paralleliums 商店",
      popularChoice: "超过72%的玩家选择",
      currency: "Paralleliums",
      price: "价格",
      buy: "购买",
      cookies: {
        message: "冒险者你好！我们使用神奇的Cookie来增强您的钓鱼体验！您愿意接受我们的神秘美食吗？",
        accept: "接受魔法！"
      }
    }
  }
});

export default i18n;
